import request from '@/utils/request'
import URL from './urlTranslator'

export function getImageTypeList() {
  return request({
    url: URL.sys.imageType,
    method: 'get'
  })
}

